// Packages Actions

import { HOWL_N_LEARN_CODE, LATE_CHECKOUT_PREFIXES } from '../../../utilities/constants';
import packagesActionTypes from './packages.types';

function upsertToPackagesArray(packagesArray, obj) {
  let result = [...packagesArray];
  const index = result.findIndex(e => matchByPackageCode(e, obj));
  if (index === -1) {
    result.push(obj);
  } else {
    result[index] = obj;
  }
  return result;
}

function removeFromPackagesArray(packagesArray, obj) {
  return packagesArray.filter(pkg => {
    if (obj.isExtra) {
      return pkg.packageCode !== obj.packageCode || (pkg.packageCode === obj.packageCode && !pkg.isExtra);
    } else {
      return pkg.packageCode !== obj.packageCode;
    }
  });
}

function matchByPackageCode(e, params) {
  if (params.isExtra) {
    return e.packageCode === params.packageCode && e.isExtra;
  } else {
    return e.packageCode === params.packageCode && !e.isExtra;
  }
}

export const upsertPackage = (
  params,
  isCartVariation,
  isBday,
  partyDate,
  partyAdults,
  partyKids,
  partyInfants,
  partySpectators,
  partyTime
) => (dispatch, getState) => {
  const state = getState();
  const currentPackages = state.packages.selectedPackages;

  let selectedPackages = upsertToPackagesArray(currentPackages, params);

  const learnPackage = selectedPackages.find(pckg => pckg.packageCode === HOWL_N_LEARN_CODE);
  if (learnPackage) {
    const lcoPackage = selectedPackages.find(selectedPackages =>
      selectedPackages.packageCode.includes(LATE_CHECKOUT_PREFIXES.code)
    );
    if (lcoPackage) {
      selectedPackages = removeFromPackagesArray(selectedPackages, lcoPackage);
    }
  }
  dispatch({
    type: packagesActionTypes.UPSERT_PACKAGES,
    selectedPackages: selectedPackages,
    isCartVariation,
    isBday,
    partyDate,
    partyAdults,
    partyKids,
    partyInfants,
    partySpectators,
    partyTime,
    recommendationVariant: params?.recommendationVariant
  });
};
export const deletePackage = (
  params,
  isBday,
  partyDate,
  partyAdults,
  partyKids,
  partyInfants,
  partySpectators,
  partyTime
) => (dispatch, getState) => {
  const currentPackages = getState().packages.selectedPackages;

  const remainingPackages = removeFromPackagesArray(currentPackages, params);
  dispatch({
    type: packagesActionTypes.DELETE_PACKAGES,
    selectedPackages: remainingPackages,
    isBday,
    partyDate,
    partyAdults,
    partyKids,
    partyInfants,
    partySpectators,
    partyTime
  });
};

export const clearSelectedPackages = () => dispatch => {
  dispatch({
    type: packagesActionTypes.SET_SELECTED_PACKAGES,
    selectedPackages: []
  });
};

export const clearPackagesByCodes = packagesCodes => (dispatch, getState) => {
  const currentPackages = getState().packages.selectedPackages;
  const selectedPackages = currentPackages.filter(
    selectedPackage => !packagesCodes.includes(selectedPackage.packageCode)
  );
  dispatch({
    type: packagesActionTypes.SET_SELECTED_PACKAGES,
    selectedPackages
  });
};
export const clearPlanPackages = () => dispatch => {
  dispatch({
    type: packagesActionTypes.CLEAR_PACKAGES_PLAN
  });
};
export const packagesImpressions = eventProps => dispatch => {
  dispatch({
    type: packagesActionTypes.GTM_PACKAGES_IMPRESSIONS,
    eventProps
  });
};
